import Post from './Post/Post'
import { useSelector } from 'react-redux'
import { Grid , CircularProgress } from '@mui/material';


const Posts = ({setCurrentId}) => {
  
 const posts = useSelector((state) => state.postsReducer.posts);   //showing the posts of our redux state
 const isLoading = useSelector((state) => state.postsReducer.isLoading);   //showing isLoading from redux state 
 
 if (!posts.length && !isLoading) {return 'No posts here!! .. please add a new post'} ;   //no posts message
  //showing the posts & passing the data as props to the single post component
  return (
    isLoading? <CircularProgress/> : (
        <Grid container alignItems="stretch" spacing={3} sx={{display: 'flex'}}>
            {posts.map((post)=>(
                  <Grid item key={post._id} xs={12} sm={12} md={6} lg={4}>
                      <Post  post={post} setCurrentId={setCurrentId}/>
                  </Grid>
            ) )}
        </Grid>
    ) 
  )
}

export default Posts